const types = {
  CHECKBOX: "check_box",
  NUMBER: "number",
  RADIO: "radio",
  SIMPLE_TEXT: "input",
  SELECT: "select",
  RANKING: "ranking",
  SIMPLE_TEXTAREA: "simple_textarea",
  TEXTAREA: "textarea",
  TITLE: "title",
  FILE: "file",
  DATE: "date",
  LOCATION: "location",
  INPUT_OTHER: "input_other",
  CONSENT_CHECKBOX: "consent_checkbox",
};

export default types;
